/*
ボタンレイアウト関連
*/

export default class Btnlayout {
    constructor() {
		this.btnlayout();
	};

    btnlayout() {
        $('.wp-block-button__link').addClass('p-article__btn p-article__flexiblebtn');
        let anchortext = $('.wp-block-button__link').text();
        $('.wp-block-button__link').html('<span class="p-article__btn-inner p-article__flexiblebtn-inner">'+anchortext+'</span>')
    }
}